module.exports = "/_next/static/images/CollectUserEventData@2x-6a0cd93d54da4569d4520b55fe70a404.webp";